import React from 'react';
import InputMask from 'react-input-mask';
import { StyledMaskedInput } from './MaskedInput.styles';

export const MaskedInput = React.forwardRef(
  (
    {
      width,
      height = 35,
      fontWeight = 'normal',
      isLoading = false,
      isDisabled,
      type = 'text',
      error,
      ...props
    },
    ref,
  ) => {
    return (
      <StyledMaskedInput
        ref={ref}
        width={width}
        height={height}
        fontWeight={fontWeight}
        isLoading={isLoading}
        isDisabled={isDisabled}
        type={type}
        error={error}
        {...props}
      />
    );
  },
);
